import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=14f339db&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14f339db')) {
      api.createRecord('14f339db', component.options)
    } else {
      api.reload('14f339db', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=14f339db&", function () {
      api.rerender('14f339db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GhxtgWr5BMSO/JS/videoIframe.vue"
export default component.exports